export const FOOTER_DATA_REQUEST = 'FOOTER_DATA_REQUEST'
export const FOOTER_DATA_REQUEST_SUCCESS = 'FOOTER_DATA_REQUEST_SUCCESS'
export const FOOTER_DATA_REQUEST_FAIL = 'FOOTER_DATA_REQUEST_FAIL'